import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ADMIN__Admin1, SIDEBAR_MAP_FILTER_FIELDS } from '../../configs/map.configs';

import { COLOR_RANGE_STEPS_DEFAULT, COLOR_RANGES } from '../../configs/mapColor.configs';
import { RENDERER_CLASSIFICATION_METHODS } from '../../configs/mapRendererClassificationMethods.configs';

export type RendererClassificationMethodType =
  | 'equal-interval'
  | 'natural-breaks'
  | 'quantile'
  | 'standard-deviation'
  | undefined;

type sidebarMapFiltersStateTypes = {
  adminSelected: string;
  fieldSelected: string;
  colorRangeSteps: number;
  colorRangeIndexSelected: number;
  colorRangeSelected: string[];
  rendererClassificationMethod: RendererClassificationMethodType;
};

const sidebarMapFiltersInitialState: sidebarMapFiltersStateTypes = {
  adminSelected: ADMIN__Admin1,
  fieldSelected: SIDEBAR_MAP_FILTER_FIELDS[0].value,
  colorRangeSteps: COLOR_RANGE_STEPS_DEFAULT,
  colorRangeIndexSelected: 0,
  colorRangeSelected: COLOR_RANGES[0].slice(0, COLOR_RANGE_STEPS_DEFAULT),
  rendererClassificationMethod: RENDERER_CLASSIFICATION_METHODS[0].value,
};

export const sidebarMapFiltersSlice = createSlice({
  name: 'sidebarMapFiltersSlice',
  initialState: sidebarMapFiltersInitialState,
  reducers: {
    setAdminSelected: (state, action: PayloadAction<string>) => {
      state.adminSelected = action.payload;
    },
    setFieldSelected: (state, action: PayloadAction<string>) => {
      state.fieldSelected = action.payload;
    },
    setColorRangeSteps: (state, action: PayloadAction<number>) => {
      state.colorRangeSteps = action.payload;
      state.colorRangeSelected = COLOR_RANGES[state.colorRangeIndexSelected].slice(0, action.payload);
    },
    setColorRangeIndexSelected: (state, action: PayloadAction<number>) => {
      state.colorRangeIndexSelected = action.payload;
    },
    setColorRangeSelected: (state, action: PayloadAction<string[]>) => {
      state.colorRangeSelected = action.payload;
    },
    setRendererClassificationMethod: (state, action: PayloadAction<RendererClassificationMethodType>) => {
      state.rendererClassificationMethod = action.payload;
    },
  },
});

export const {
  setAdminSelected,
  setFieldSelected,
  setColorRangeSteps,
  setColorRangeIndexSelected,
  setColorRangeSelected,
  setRendererClassificationMethod,
} = sidebarMapFiltersSlice.actions;

export const $adminSelected = (state: RootState) => state.sidebarMapFiltersSlice.adminSelected;
export const $fieldSelected = (state: RootState) => state.sidebarMapFiltersSlice.fieldSelected;
export const $colorRangeSteps = (state: RootState) => state.sidebarMapFiltersSlice.colorRangeSteps;
export const $colorRangeIndexSelected = (state: RootState) => state.sidebarMapFiltersSlice.colorRangeIndexSelected;
export const $colorRangeSelected = (state: RootState) => state.sidebarMapFiltersSlice.colorRangeSelected;
export const $rendererClassificationMethod = (state: RootState) =>
  state.sidebarMapFiltersSlice.rendererClassificationMethod;

export default sidebarMapFiltersSlice.reducer;
